import useAbortPinPost from "../mutations/pin/useAbortPinPost";
import useAbortSplitPaymentPinPost from "../mutations/pin/useAbortSplitPaymentPinPost";

const useAbortPinHook = (isSplitPayment: boolean) => {
  const mutation = useAbortPinPost();
  const splitPaymentMutation = useAbortSplitPaymentPinPost();

  return isSplitPayment ? splitPaymentMutation : mutation;
};

export default useAbortPinHook;
